import { createRouter, createWebHashHistory } from "vue-router";
import store from "@/store/index.js";
// auth
import Login from "@/views/auth/Login.vue";
import Error from "@/views/auth/Error.vue";
//Configurations
// import Divisions from "@/views/configuration/Divisions.vue"; // Divisions page hidden
import SubDivisions from "@/views/configuration/SubDivision.vue";
import Circles from "@/views/configuration/Circles.vue";
import PoliceStation from "@/views/configuration/PoliceStation.vue";
import MajorHead from "@/views/configuration/MajorHead.vue";
import MinorHead from "@/views/configuration/MinorHead.vue";
import RowdyStatus from "@/views/configuration/RowdyStatus.vue";
// gangs
import GangList from "@/views/gangs/GangList.vue";
import GangDetails from "@/views/gangs/GangDetails.vue";
import OppositeGang from "@/views/gangs/OppositeGang.vue";
import CreateGang from "@/views/gangs/CreateGang.vue";

// rowdy
import AllRowdyList from "@/views/rowdy/AllRowdyList.vue";
import RowdyDetails from "@/views/rowdy/RowdyDetails.vue";
import CreateRowdy from "@/views/rowdy/CreateRowdy.vue";
import RowdyCaseCreate from "@/views/rowdy/CreateCase.vue";
import RowdyProcessCreate from "@/views/rowdy/CreateProcess.vue";
import RowdyGoondaCreate from "@/views/rowdy/CreateGoonda.vue";
import ViewRowdy from "@/views/rowdy/ViewRowdy.vue";
import ParCreate from "@/views/rowdy/ParCreate.vue";
import SearchRowdy from "@/views/rowdy/SearchRowdy.vue";

// users
import UserCreate from "@/views/users/UserCreate.vue";
import UsersList from "@/views/users/UsersList.vue";
import ProfileUpdate from "@/views/users/ProfileUpdate.vue";
import Permissions from "@/views/users/Permissions.vue";
// roles
import Roles from "@/views/users/Roles.vue";
import Designation from "@/views/users/Designation.vue";

// rowdy sheeters report
import RowdySheeter from "@/views/reports/RowdySheeter.vue";
import RowdySheeterStatistics from "@/views/reports/RowdySheeterStatistics.vue";
// import RowdyAlerts from "@/views/rowdy/RowdyAlerts.vue"; // Alerts page hidden
import Analytics from "@/views/analytics/Analytics.vue";

const routes = [
	//Authentication
	{
		path: "/",
		name: "Login",
		component: Login,
		meta: { unAuth: true, permission: "All" },
	},
	{
		path: "/login",
		name: "login",
		component: Login,
		meta: { unAuth: true, permission: "All" },
	},
	{
		path: "/error",
		name: "Error",
		component: Error,
		meta: { auth: true, permission: "All" },
	},
	// Configuration
	// Divisions page hidden
	// {
	// 	path: "/divisions",
	// 	name: "Divisions",
	// 	component: Divisions,
	// 	meta: { auth: true, permission: "division.view" },
	// },
	{
		path: "/sub_divisions",
		name: "SubDivisions",
		component: SubDivisions,
		meta: { auth: true, permission: "sub_division.view" },
	},
	{
		path: "/circles",
		name: "Circles",
		component: Circles,
		meta: { auth: true, permission: "circle.view" },
	},
	{
		path: "/police_stations",
		name: "PoliceStation",
		component: PoliceStation,
		meta: { auth: true, permission: "police_station.view" },
	},
	{
		path: "/major_heads",
		name: "MajorHead",
		component: MajorHead,
		meta: { auth: true, permission: "major_head.view" },
	},
	{
		path: "/minor_heads",
		name: "MinorHead",
		component: MinorHead,
		meta: { auth: true, permission: "minor_head.view" },
	},
	{
		path: "/rowdy_status",
		name: "RowdyStatus",
		component: RowdyStatus,
		meta: { auth: true, permission: "rowdy_status.view" },
	},
	//Gangs
	{
		path: "/gang_list",
		name: "GangList",
		component: GangList,
		meta: { auth: true, permission: "gang.gang_list" },
	},
	{
		path: "/gang_details/:gang_id",
		name: "GangDetails",
		component: GangDetails,
		meta: { auth: true, permission: "gang.view" },
	},
	{
		path: "/opposite_gang",
		name: "OppositeGang",
		component: OppositeGang,
		meta: { auth: true, permission: "gang.assign_opposite_gang" },
	},
	{
		path: "/create_gang",
		name: "CreateGang",
		component: CreateGang,
		meta: { auth: true, permission: "gang.create" },
	},
	{
		path: "/update_gang/:gang_id",
		name: "UpdateGang",
		component: CreateGang,
		meta: { auth: true, permission: "gang.update" },
	},

	// rowdy
	{
		path: "/all_rowdy_list",
		name: "AllRowdyList",
		component: AllRowdyList,
		meta: { auth: true, permission: "rowdy.rowdy_list" },
	},
	{
		path: "/rowdy_details/:rowdy_id",
		name: "RowdyDetails",
		component: RowdyDetails,
		meta: { auth: true, permission: "rowdy.view" },
	},
	{
		path: "/create_rowdy",
		name: "CreateRowdy",
		component: CreateRowdy,
		meta: { auth: true, permission: "rowdy.create" },
	},
	{
		path: "/update_rowdy/:rowdy_id",
		name: "UpdateRowdy",
		component: CreateRowdy,
		meta: { auth: true, permission: "rowdy.update" },
	},
	{
		path: "/update_cases_processes/:rowdy_id",
		name: "UpdateCases",
		component: CreateRowdy,
		meta: { auth: true, permission: "All" },
	},
	{
		path: "/rowdy_case_create/:rowdy_id",
		name: "RowdyCaseCreate",
		component: RowdyCaseCreate,
		meta: { auth: true, permission: "cases.add" },
	},
	{
		path: "/rowdy_case_update/:rowdy_id/:rowdies_case_id",
		name: "RowdyCaseUpdate",
		component: RowdyCaseCreate,
		meta: { auth: true, permission: "cases.update" },
	},
	{
		path: "/rowdy_process_create/:rowdy_id",
		name: "RowdyProcessCreate",
		component: RowdyProcessCreate,
		meta: { auth: true, permission: "process.add" },
	},
	{
		path: "/rowdy_process_update/:rowdy_id/:process_id",
		name: "RowdyProcessUpdate",
		component: RowdyProcessCreate,
		meta: { auth: true, permission: "process.delete" },
	},
	{
		path: "/rowdy_goonda_create/:rowdy_id",
		name: "RowdyGoondaCreate",
		component: RowdyGoondaCreate,
		meta: { auth: true, permission: "goonda_act.add" },
	},
	{
		path: "/rowdy_goonda_update/:rowdy_id/:goonda_id",
		name: "RowdyGoondaUpdate",
		component: RowdyGoondaCreate,
		meta: { auth: true, permission: "goonda_act.update" },
	},
	{
		path: "/view_rowdy/:rowdy_id",
		name: "ViewRowdy",
		component: ViewRowdy,
		meta: { auth: true, permission: "rowdy.view" },
	},
	{
		path: "/rowdy_par_create/:rowdy_id",
		name: "ParCreateCase",
		component: ParCreate,
		meta: { auth: true, permission: "par_case.add" },
	},
	{
		path: "/rowdy_par_update/:rowdy_id/:par_case_id",
		name: "ParUpdateCase",
		component: ParCreate,
		meta: { auth: true, permission: "par_case.update" },
	},
	{
		path: "/search_rowdy",
		name: "SearchRowdy",
		component: SearchRowdy,
		meta: { auth: true, permission: "rowdy.search" },
	},
	// {
	// 	path: "/rowdy_alerts",
	// 	name: "RowdyAlerts",
	// 	component: RowdyAlerts,
	// 	meta: { auth: true, permission: "rowdy.alert" },
	// },
	 {
        path: "/analytics",
        name: "Analytics",
		component: Analytics,
		meta: { auth: true, permission: "analytics.view" },
    },

	// User Management
	{
		path: "/user_create",
		name: "UserCreate",
		component: UserCreate,
		meta: { auth: true, permission: "user.create" },
	},

	{
		path: "/user_update/:user_id",
		name: "UserUpdate",
		component: UserCreate,
		meta: { auth: true, permission: "user.update" },
	},

	{
		path: "/users_list",
		name: "UsersList",
		component: UsersList,
		meta: { auth: true, permission: "user.view" },
	},
	{
		path: "/profile_update",
		name: "ProfileUpdate",
		component: ProfileUpdate,
		meta: { auth: true, permission: "All" },
	},
	{
		path: "/permissions",
		name: "Permission",
		component: Permissions,
		meta: { auth: true, permission: "permission.settings" },
	},

	//Reports
	{
		path: "/rowdy_sheeter_report",
		name: "RowdySheeter",
		component: RowdySheeter,
		meta: { auth: true, permission: "police_station_report.view" },
	},
	{
		path: "/rowdy_sheeter_statistics",
		name: "RowdySheeterStatistics",
		component: RowdySheeterStatistics,
		meta: { auth: true, permission: "statistics.view" },
	},

	// Roles
	{
		path: "/roles",
		name: "Roles",
		component: Roles,
		meta: { auth: true, permission: "user.view" },
	},
	{
		path: "/designations",
		name: "Designation",
		component: Designation,
		meta: { auth: true, permission: "designation.view" },
	},
];

const router = createRouter({
	history: createWebHashHistory(),
	routes,
});

router.beforeEach(function (to, _, next) {
	if (store.getters.isLoggingOut) {
		next("/");
		return;
	}

	// Hydrate store from session storage on hard refresh before checking auth.
	if (!store.getters.user) {
		const userRaw = sessionStorage.getItem("user");
		if (userRaw && userRaw !== "undefined") {
			try {
				store.commit("setUser", JSON.parse(userRaw));
			} catch (e) { /* ignore */ }
		}
	}
	if (!store.getters.token) {
		const token = sessionStorage.getItem("token");
		if (token) store.commit("setToken", token);
	}
	const permissionsRaw = sessionStorage.getItem("permissions");
	if ((store.getters.permissions || []).length === 0 && permissionsRaw && permissionsRaw !== "undefined") {
		try {
			store.commit("setPermissions", JSON.parse(permissionsRaw));
		} catch (e) { /* ignore */ }
	}

	if (to.meta.auth && !store.getters.user) {
		next("/");
		return;
	}
	if (to.meta.unAuth && store.getters.user) {
		next("/all_rowdy_list");
		return;
	}

	const requiredPermission = to.meta.permission;
	if (!requiredPermission || requiredPermission === "All") {
		next();
		return;
	}

	const permissions = Array.isArray(store.getters.permissions) ? store.getters.permissions : [];
	if (permissions.length === 0) {
		next("/error");
		return;
	}

	const allowed = permissions.some((el) => el?.ability?.ability === requiredPermission);
	if (allowed) next();
	else next("/error");
});

export default router;
